import styles from "./styles.module.css";

export default function Vignette() {
  return <div className={styles.vignette}></div>;
}
